
import { gql, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Container, Header, Segment } from 'semantic-ui-react';

import { PATHS } from '../../paths';
import banner from '../../images/login-banner.png';
import styles from './Organisations.module.css';

const GET_ORGANISATIONS = gql`
    query Organisation {
        me {
            isAdminInWorkingOrganisation
            organisations {
                id
                name
                isSupportingOrganisation
            }
        }
    }
`;

const LOADING_MESSAGES = [
    'Loading your community…',
    'Connecting to your organisation…',
    'Almost ready…',
    'Just a moment more…',
];

const Organisations = () => {
    const navigate = useNavigate();
    const { loading, error, data } = useQuery(GET_ORGANISATIONS);
    const [msgIndex, setMsgIndex] = useState(0);

    useEffect(() => {
        if (data && data.me.organisations.length === 1) {
            if (data.me.isAdminInWorkingOrganisation) {
                navigate(PATHS.PEOPLE);
            } else if (data.me.organisations[0].isSupportingOrganisation) {
                navigate(PATHS.OVERVIEW);
            } else {
                navigate(PATHS.CLASSES);
            }
        }
    }, [data]);

    // Redirect to logout if still loading after 5 seconds
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (loading) navigate(PATHS.LOGOUT);
        }, 5000);
        return () => clearTimeout(timeout);
    }, [loading]);

    // Cycle through messages while loading
    useEffect(() => {
        if (!loading) return;
        const interval = setInterval(() => {
            setMsgIndex(i => Math.min(i + 1, LOADING_MESSAGES.length - 1));
        }, 1200);
        return () => clearInterval(interval);
    }, [loading]);

    if (loading || error) {
        return (
            <div className={styles.page}>
                <div className={styles.brandBar}>
                    <img src={banner} alt="Joyya" className={styles.brandLogo} />
                </div>
                <div className={styles.content}>
                    <div className={styles.spinner} />
                    <p key={msgIndex} className={styles.message}>
                        {error ? 'Something went wrong. Please try again.' : LOADING_MESSAGES[msgIndex]}
                    </p>
                    {!error && (
                        <div className={styles.progressTrack}>
                            <div className={styles.progressFill} />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // TODO: support selecting between multiple organisations
    return (
        <Segment style={{ padding: '2em 0em' }} vertical>
            <Container>
                <Header as='h1'>Organisations</Header>
                {data.me.organisations.map((o: any) => (
                    <div key={o.id}>{o.name}</div>
                ))}
            </Container>
        </Segment>
    );
};

export { Organisations };
